import extractErrorMessage from 'src/plugins/helpers/extract-error-message'
import { isStillParked } from 'src/plugins/helpers/parked-call'
import { mapActions, mapState } from 'vuex'

export default {
  computed: {
    ...mapState([
      'loadingParkedCalls',
      'parkedCalls'
    ])
  },

  created () {
    this.$VueEvent.listen('update_communication', this.parkedCallUpdateListener)
  },

  beforeDestroy () {
    this.$VueEvent.stop('update_communication', this.parkedCallUpdateListener)
  },

  methods: {
    ...mapActions([
      'setParkedCalls',
      'setLoadingParkedCalls',
      'addParkedCall',
      'removeParkedCall'
    ]),

    parkedCallUpdateListener (data) {
      if (!this.checkCommunicationMatchesUserAccessibility(data)) {
        return
      }

      if (isStillParked(data)) {
        this.addParkedCall(data)
        return
      }

      this.removeParkedCall(data.id)
    },

    fetchAllParkedCalls () {
      this.setLoadingParkedCalls(false)
      return this.$axios
        .post('/api/v1/contact-center/parked-calls')
        .then((res) => {
          this.setParkedCalls(res.data)
          this.setLoadingParkedCalls(false)
          return Promise.resolve()
        })
        .catch((error) => {
          const {
            message,
            html
          } = extractErrorMessage(error)
          console.log(html)
          this.$generalNotification(message, 'error')
          this.setLoadingParkedCalls(false)
          return Promise.reject()
        })
    }
  }
}
